import { ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Preloader, ThreeDots } from "react-preloader-icon";
import Navbar from "../../components/Navbar/Navbar";
import NavigationBar from "../../components/NavigationBar/NavigationBar";
import { apiGetHistory } from "../../services/apis/profile";
import { numberWithCommas } from "../../untills/function";

import "moment/locale/th";

import "antd/dist/antd.css";
import "./History.css";

const History = () => {
  const [listHistory, setListHistory] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = async () => {
    setIsLoading(true);
    let history = await apiGetHistory();
    console.log(history);
    if (history && history.status) {
      setIsLoading(false);
      setListHistory(history);
    } else {
      setIsLoading(false);
    }
  };

  const renderIcon = (type) => {
    switch (type) {
      case "TOPUP":
        return "/assets/machine/topup.png";
      case "WASHER":
        return "/assets/machine/e-wash.png";
      case "DRYER":
        return "/assets/machine/e-dry.png";
      default:
        return "/assets/machine/topup.png";
    }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="bx-history">
        <h3 className="title-topup">ประวัติการทำรายการ</h3>
        <div className="bx-list-history">
          {isLoading ? (
            <div>
              {" "}
              <Preloader
                use={ThreeDots}
                size={60}
                strokeWidth={6}
                strokeColor="#c55a59"
                duration={2000}
              />
            </div>
          ) : (
            listHistory &&
            listHistory.result.length > 0 &&
            listHistory.result.map((v, i) => (
              <div key={v.id} className="cov-history">
                <div className="icon-status">
                  <img alt="" className="img-status" src={renderIcon(v.type)} />
                </div>
                <div className="de-use">
                  <p className="txt-status">
                    {v.description.th} {v.machine.name_th}
                  </p>
                  <p className="txt-status">{v.site.name_th}</p>
                  <p className="txt-date">
                    <ClockCircleOutlined
                      style={{ color: "#999", marginRight: "3px" }}
                    />{" "}
                    {moment
                      .utc(v.create_date)
                      .local()
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className="total-use">
                  <p className="txt-num">{numberWithCommas(v.amount)} บาท</p>
                </div>
              </div>
            ))
          )}
          {/* <div className='cov-history'>
                        <div className='icon-status'>
                            <img className='img-status' src='/assets/machine/topup.png' />
                        </div>
                        <div className='de-use'>
                            <p className='txt-status'>เติมเงิน</p>
                            <p className='txt-date'><ClockCircleOutlined style={{ color: '#999', marginRight: '3px' }} /> 12/02/2022 15:35</p>
                        </div>
                        <div className='total-use'>
                            <p className='txt-num'>1 บาท</p>
                        </div>
                    </div>

                    <div className='cov-history'>
                        <div className='icon-status'>
                            <img className='img-status' src='/assets/machine/e-wash.png' />
                        </div>
                        <div className='de-use'>
                            <p className='txt-status'>เติมเงิน</p>
                            <p className='txt-date'><ClockCircleOutlined style={{ color: '#999', marginRight: '3px' }} /> 12/02/2022 15:35</p>
                        </div>
                        <div className='total-use'>
                            <p className='txt-num'>1 บาท</p>
                        </div>
                    </div>

                    <div className='cov-history'>
                        <div className='icon-status'>
                            <img className='img-status' src='/assets/machine/e-dry.png' />
                        </div>
                        <div className='de-use'>
                            <p className='txt-status'>เติมเงิน</p>
                            <p className='txt-date'><ClockCircleOutlined style={{ color: '#999', marginRight: '3px' }} /> 12/02/2022 15:35</p>
                        </div>
                        <div className='total-use'>
                            <p className='txt-num'>1 บาท</p>
                        </div>
                    </div> */}
        </div>
      </div>

      <NavigationBar />
    </div>
  );
};

export default History;
